export default "__VITE_ASSET__BRhEzfVF__"